/**
 * Google Analytics 4 helpers — used only from public pages.
 *
 * The base loader lives in /public/index.html wrapped in a `!location.pathname
 * .startsWith('/admin')` guard, so it never runs when the app is served under
 * /admin/*. These helpers mirror the same guard defensively in case a public
 * component ever gets rendered from a sub-route we forgot about.
 */
const GA_MEASUREMENT_ID = "G-JHH6FQDKEH";

function isPublicPath() {
  if (typeof window === "undefined") return false;
  return !window.location.pathname.startsWith("/admin");
}

/**
 * Lazily inject the GA4 snippet if the user landed on /admin/* first (where
 * the base loader skipped) and then navigated client-side into a public
 * route. Safe to call multiple times — no-op if gtag already exists.
 */
function ensureGaLoaded() {
  if (typeof window === "undefined") return;
  if (window.gtag) return;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", GA_MEASUREMENT_ID);
}

/** Fires a page_view. Called on every SPA route change from App.js. */
export function trackGaPageView(pathname) {
  if (!isPublicPath()) return;
  ensureGaLoaded();
  if (window.gtag) {
    window.gtag("event", "page_view", {
      page_path: pathname || window.location.pathname,
      page_location: window.location.href,
      page_title: document.title,
    });
  }
}
